"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../util");
var communicationMap = {};
var communicationException = function (method, params, callback) {
    if (callback === void 0) { callback = util_1.noop; }
    var err = {
        errno: 1010101,
        errmsg: '无法调用端内方法，请确认所在端或配置是否正确'
    };
    callback(err, null);
};
function generateCommunication(config, app) {
    if (!config || (typeof config.type !== 'function' && typeof config.factory !== 'function')) {
        return communicationException;
    }
    var communication = config.factory;
    var env = app.env || '';
    var type = communication.type || communication.tmpName;
    if (!type) {
        type = "custom-communication-" + Date.now();
        communication.tmpName = type;
    }
    if (!communicationMap[env]) {
        communicationMap[env] = {};
    }
    if (communicationMap[env][type]) {
        return communicationMap[env][type];
    }
    var call = communication(app, config.options);
    communicationMap[env][type] = call;
    app.communication = type;
    return call;
}
exports.generateCommunication = generateCommunication;
